module.exports = __webpack_public_path__ + "assets/7a7cd6c6c008dc8fd9b3d7a63f991a81.mp4";